import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ControlUsuariosScreen from './screen';
import { PartesAdapter, FiltroPartes } from '../../../../../infraestructure/persistence/rest/PartesAdapter';
import { DescargasAdapter } from '../../../../../infraestructure/persistence/rest/DescargasAdapter';
import { FacturasAdapter } from '../../../../../infraestructure/persistence/rest/FacturasAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { downloadFile } from '../../../../../shared/utils/download';
import { GetTitleFileCP, GetTitleFileFactFinal, GetTitleFileProvincia, GetTitleFileUsuario } from './constants';

const ControlUsuariosContainer = () => {

	const apiPartes:any = new PartesAdapter();
	const apiDesc:any = new DescargasAdapter();
	const apiFac:any = new FacturasAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();

	let [ data, setData ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState<boolean>(false);
	let result: any;

	const getData = async(filtro: FiltroPartes ) => {
		setIsLoading(true)
		try {
			result = await apiPartes.ListarDatosPartesUsuarios(filtro);
			if(result.data && result.data!=="")
			{
				setData([ ...result.data ]);
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	}

	const DownloadDatosCoste = async (filter:any) => {
		setIsLoading(true)
		try {
			result = await apiDesc.DatosCoste(filter);
			if(result.data && result.data!=="")
			{
				let _tipo="";
				switch (filter.tipo) {
					case "DN":_tipo='Datos_Costes_DN-SG';break;
					case "SO":_tipo='Datos_Costes_Sociedad';break;
					case "US":_tipo='Horas_Facturables_Usuario';break;
					default:break;
				}

				downloadFile(result.data,`${_tipo}.xlsx`);
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

	const DownloadEmpleadoSociedadesHoras = async (filter:any) => {
			setIsLoading(true)
			//filter.perfil = profile;
			try {
				result = await apiDesc.DatosDedicacionHoras(filter);
				if(result.data && result.data!=="")
				{
					downloadFile(result.data,`Datos_Empleados_Sociedades_Horas.xlsx`);
				}else{resultError()}
				setIsLoading(false)
			} catch (error) {
				let exception = ServerErrorMessage(error);
				exceptionError(exception)
				setIsLoading(false)
			}
	};

	const DownloadDatosFacturacionFinal = async (dataDownload:any) => {
		
		setIsLoading(true)
		const tipoFacturacion = dataDownload.tipoFacturacion.descripcion;
		dataDownload.tipoFacturacion = dataDownload.tipoFacturacion.idSociedadOriginal
		
		try {
			
			result = await apiDesc.DatosFacturacionFinal(dataDownload);
			if(result.data && result.data!=="")
			{
				downloadFile(result.data,GetTitleFileFactFinal(dataDownload.fechaFacturacion,dataDownload.soloValidados,tipoFacturacion));
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

	const DownloadDatosFacturacionCP = async (dataDownload:any) => {
		setIsLoading(true)
		const tipoFacturacion = dataDownload.tipoFacturacion.descripcion;
		dataDownload.tipoFacturacion = dataDownload.tipoFacturacion.idSociedadOriginal
		try {
			result = await apiDesc.DatosFacturacionCP(dataDownload);
			if(result.data && result.data!=="")
			{
				downloadFile(result.data,GetTitleFileCP(dataDownload.fechaFacturacion,dataDownload.soloValidados,tipoFacturacion));
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

	const DownloadDatosFacturacionUsuario = async (dataDownload:any) => {
		setIsLoading(true)
		const tipoFacturacion = dataDownload.tipoFacturacion.descripcion;
		dataDownload.tipoFacturacion = dataDownload.tipoFacturacion.idSociedadOriginal
		try {
			result = await apiDesc.DatosFacturacionUsuario(dataDownload);
			if(result.data && result.data!=="")
			{
				downloadFile(result.data,GetTitleFileUsuario(dataDownload.fechaFacturacion,dataDownload.soloValidado,tipoFacturacion));
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

	const DownloadInformeFacturacionPorProvincia = async (dataDownload:any) => {
		setIsLoading(true)
		const tipoFacturacion = dataDownload.tipoFacturacion.descripcion;
		dataDownload.tipoFacturacion = dataDownload.tipoFacturacion.idSociedadOriginal
		try {
			result = await apiFac.InformeFacturacionPorProvincia(dataDownload);
			if(result.data && result.data!=="")
			{
				downloadFile(result.data,GetTitleFileProvincia(dataDownload.fechaFacturacion,dataDownload.soloValidados,tipoFacturacion));
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

	/*GENERAR HISTORICOS*/
	const GenerarFacturas = async (dataFacturacion:any) => {
		
		setIsLoading(true)
		try {
			result = await apiFac.Facturar(dataFacturacion);
			if(result.data && result.data!=="")
			{
				launchNotification({type:"success",title:"Facturación",message:"Se han generado nuevos ficheros de facturación."})
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

	return (
		<ControlUsuariosScreen
			data={data}
			isLoading={isLoading}
			handleFilter={getData}
			handleFacturar={GenerarFacturas}
			//handleDownloadDatosFacOficial = {DownloadDatosFacturacionOficial}
			handleDownloadDatosCoste = {DownloadDatosCoste}
			handleDownloadDedicacionHoras={DownloadEmpleadoSociedadesHoras}
			handleDownloadDatosFacFinal = {DownloadDatosFacturacionFinal}
			handleDownloadDatosFacCP = {DownloadDatosFacturacionCP}
			handleDownloadDatosFacUsuario= {DownloadDatosFacturacionUsuario}
			handleDownloadDatosFacPorProvincia={DownloadInformeFacturacionPorProvincia}
		/>
	);
};

export default ControlUsuariosContainer;
